// As we're using immer
import { createSelector, createSlice } from '@reduxjs/toolkit';
import { isArray, isEmpty, uniqBy } from 'lodash';
import { EditorModes } from './constants';
const INITIAL_STATE = {
    tasks: {
        items: [],
        apiDone: false,
        loading: false,
        documentRef: {},
        activeTaskId: null,
        sectionNameIdMap: {}
    },
    resourceSections: {
        items: []
    },
    taskSectionIdMap: {},
    items: [],
    active: {
        documentId: null,
        projectId: null,
        publicSection: {
            type: EditorModes.Public
        },
        privateSection: {
            type: EditorModes.Private
        }
    }
};
const DocumentsSlice = createSlice({
    name: 'documents',
    initialState: INITIAL_STATE,
    reducers: {
        setDocuments (state, action) {
            state.items = action.payload;
        },
        setActiveDocument (state, action) {
            state.active = {
                ...state.active,
                ...action.payload
            };
        },
        setTasksLoading (state, action) {
            state.tasks.loading = action.payload;
        },
        updateActiveTask (state, action) {
            state.tasks.activeTaskId = action.payload;
        },
        setTasksDocMap (state, action) {
            state.tasks.documentRef = {
                ...state.tasks.documentRef,
                ...action.payload
            };
        },
        appendToTasksDocMap (state, action) {
            state.tasks.documentRef = {
                ...state.tasks.documentRef,
                ...action.payload
            };
        },
        setTaskSectionNameIdMap (state, action) {
            state.tasks.sectionNameIdMap = {
                ...state.tasks.sectionNameIdMap,
                ...action.payload
            };
        },
        updateTasksDocMapWithKeys (state, action) {
            const { parentDocId } = state.tasks.documentRef[action.payload[0]] || {};
            Object.keys(state.tasks.documentRef).forEach((key)=>{
                var _state_tasks_documentRef_key;
                if (state.tasks.documentRef[key] && ((_state_tasks_documentRef_key = state.tasks.documentRef[key]) === null || _state_tasks_documentRef_key === void 0 ? void 0 : _state_tasks_documentRef_key.parentDocId) === parentDocId) {
                    state.tasks.documentRef[key].isActive = false;
                }
            });
            action.payload.forEach((key)=>{
                if (state.tasks.documentRef[key]) {
                    state.tasks.documentRef[key].isActive = true;
                }
            });
        },
        setDocumentResources (state, action) {
            if (state.resourceSections.items && isArray(state.resourceSections.items) && action.payload && isArray(action.payload)) {
                state.resourceSections.items = uniqBy(action.payload.concat(state.resourceSections.items), 'resourceSectionId');
            } else {
                state.resourceSections.items = action.payload;
            }
        },
        setTaskIdMap (state, action) {
            if (state.taskSectionIdMap && !isEmpty(state.taskSectionIdMap) && action.payload && !isEmpty(action.payload)) {
                state.taskSectionIdMap = {
                    ...state.taskSectionIdMap,
                    ...action.payload
                };
            } else {
                state.taskSectionIdMap = action.payload;
            }
        },
        updateResourceSection (state, action) {
            state.resourceSections.items = uniqBy([
                action.payload,
                ...state.resourceSections.items
            ], 'resourceSectionId');
        }
    }
});
export const selectDocuments = (state)=>state.documents.items;
export const selectActiveDocumentInfo = (state)=>state.documents.active;
export const selectDocumentActiveTaskId = (state)=>state.documents.tasks.activeTaskId;
export const selectDocumentTasksContentMap = (state)=>state.documents.tasks.documentRef;
export const selectTaskSectionIdNameMap = (state)=>state.documents.tasks.sectionNameIdMap;
export const selectTaskSectionIdMap = (state)=>state.documents.taskSectionIdMap;
export const selectDocumentResourceSections = createSelector((state)=>state.documents.resourceSections.items, (resourceSections)=>resourceSections);
// TODO: Check whether I need this. let saga take care of this?
export const { setDocuments, setActiveDocument, setTasksLoading, updateActiveTask, setTasksDocMap, appendToTasksDocMap, setTaskSectionNameIdMap, updateTasksDocMapWithKeys, setDocumentResources, setTaskIdMap, updateResourceSection } = DocumentsSlice.actions;
export const documentsReducer = DocumentsSlice.reducer;
